import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { ISession, IDomains, ISideBarItem } from '../../types';
import { mapState } from 'vuex';

@Component({
  computed: mapState({

    Authenticated: (state: { session: ISession }) => state.session.UserId ? true : false,
    Username: (state: { session: ISession }) => state.session.fullName,
    Moderator: (state: { session: ISession }) => state.session.roles != undefined ? true : false,
    User: (state: { session: ISession }) => state.session.UserId,
    UserId: (state: { session: ISession }) => state.session.service
  })
})

export default class Sidebar extends Vue {

  private namespace: string = '/SideBar';
  
  @Prop()
  private sidebarExpanded!: boolean;

  private Authenticated!: boolean;

  private Username!: string;

  private Moderator!: boolean;

  private User!: string;

  private UserId!: string;

  private menuItems: ISideBarItem[] = [];

  private accountEndpoints: string[] = [
    // '/UserLogo', 
    '/UserLastLogin'
  ];

  private services: IDomains[] | null = null;

  private selectedMenuItem: string = 'keywords';

  private userLastLogin: string = '';

  private userLogo: any = null;

  private submenuVisible: boolean = false;

  private servicesVisible: boolean = false;

  private error: boolean = false;

  private set ServiceId(id: number) {

    if (this.servicesVisible) {

      this.servicesVisible = !this.servicesVisible;
    } 

    this.$store.commit('saveServiceId', id);
  }

  private get ServiceId(): number {

    return this.$store.state.session.serviceId;
  }

  private get ServiceName () {

    if (this.services != null) {

      const service = this.services.find(service => service.serviceId === this.ServiceId);

      if (service != null) {

        return service.domain;
      }

      return this.$tc('shared.notSet', 1);
    }

    return this.$tc('shared.notSet', 1);
  }

  private get UserName () {

    if (this.Moderator && this.userLastLogin != '') {

      return this.userLastLogin;
    }

    if (this.Username && !this.Moderator) {

      return this.Username
    }

    return this.$tc('shared.notSet', 1);
  }

  mounted () {
     
    if (this.Authenticated && this.UserId) {
      this.getServices(this.Moderator ? this.UserId : this.User);
    }

    if (this.ServiceId != null && this.menuItems.length == 0) {

      this.getMenu();
    }
  }

  private itemActions (name: string, event: Event) {
    
    const item = this.menuItems.find(n => n.name == name);

    if (item != null && item.children instanceof Array) {

      if (item.enabled == null) {

        return false;
      }

      if (this.selectedMenuItem != name) {

        this.submenuVisible = false;
      }
  
      this.selectedMenuItem = name;
  
      this.submenuVisible = !this.submenuVisible;
    
    } else if ('logout' === name) {
      
      this.$emit('logout');
    }

    event.preventDefault();

    event.stopPropagation();
  }

  private disabled (item: ISideBarItem) {

    return !item.implemented || (item.optional && (item.enabled === undefined || !item.enabled));
  }

  private submenuExpand (item: ISideBarItem) {
    
    return this.sidebarExpanded && item.enabled && this.selectedMenuItem === item.name && this.submenuVisible;
  }

  private async getMenu () {
  
    this.menuItems = (await this.$axios.get<ISideBarItem[]>(`${this.$apiUrl + this.namespace}/Sections`)).data;
    
    setTimeout(() => {

      const toplevelItems = this.menuItems.filter(item => item.optional);

      toplevelItems.forEach(item => {

        if (item.children === undefined) {

          this.$axios.get(`${this.$apiUrl + this.namespace}/show/${item.name}`, {
            params: {serviceId: this.ServiceId}
          })
        
          .then( response => {
            
            this.menuItems.find((enabled, i) => enabled.name === item.name
                ? this.$set(this.menuItems[i], 'enabled', response.data)
                : false
            );
          });
        } else {

          let sublevelItems: ISideBarItem[] = [],
              childrenLength = item.children.length;
              
          item.children.forEach(child => {
            this.$axios.get(`${this.$apiUrl + this.namespace}/show/${child.name}`, {
              params: {serviceId: this.ServiceId}
            })

            .then(response => {
              
              childrenLength--;
                
              if(response.data) {
                sublevelItems.push(child);
              } 

              if (childrenLength < 1) {

                this.menuItems.find((enabled, i) => {
          
                  if (enabled.name === item.name) {
                    
                    this.menuItems[i].children = sublevelItems.sort((a, b) => (a.name > b.name) ? 1 : -1);
                      
                    return this.$set(this.menuItems[i], 'enabled', sublevelItems.length > 0);
                  }
                });
              }
            });
          });
        }
      });
    }, 250);
  }

  private async getAccountDetails (endpoints: string[], params: {}) {

    endpoints.forEach(async endpoint => {

      try {

        if (!this.Moderator && '/UserLastLogin' === endpoint) {
      
          return false;
        }

        const response = await this.$axios.get(`${this.$apiUrl + this.namespace + endpoint}`, {params}),
              property = endpoint.charAt(1).toLowerCase() + endpoint.substring(2).replace('/', '');

        if (this.accountEndpoints.includes(endpoint) && response.data != null) {

          this.$set(this, property, response.data);
        }

      } catch (err) {

        console.error(err);
      }
    });
  }

  private async getServices (userId: string) {

    try {

      const response = await this.$axios.get(`${this.$apiUrl}/Account/SingleUserServices`, {
        params: { userId }
      });

      if (response.status != 200) {

        throw new Error('Ooops...');
      }

      this.services = response.data[0].domains;
      
      this.ServiceId = response.data[0].domains[0].serviceId;

    } catch (err) {
    
      this.error = !this.error;
      return null;

    } finally {

      this.getAccountDetails(this.accountEndpoints, { userId: this.Moderator ? this.UserId : this.User });
    }
  }

  @Watch('ServiceId')
  private updateMenu (nextId: number, prevId: number | null) {

    if (nextId != null && nextId != prevId) {

      this.menuItems = [];
      this.getMenu();
      return;
    }
  }

  // Enduser
  @Watch('User', {immediate: true})
  private getSingleUserServices (nextId: string, prevId: string | null) {

    if (nextId != null && this.Authenticated && nextId != prevId) {
      
      this.getServices(this.User);
      this.menuItems = [];
      this.getMenu();
      return;
    }
  }

  // User selected by Moderator
  @Watch('UserId')
  private updateServices (nextId: string, prevId: string | null) {

    if (nextId != null && this.Moderator && nextId != prevId) {
      
      this.getServices(this.UserId);
      this.menuItems = [];
      this.getMenu();
      return;
    }
  }
}